import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { UserService } from '@/core/services/open-api/user.service';
import { StdToasts, ToastService } from '@/core/services/toast.service';

@Component({
    selector: 'app-new-password-page',
    templateUrl: './new-password.component.html',
    // styleUrls: ['./new-password.component.scss'],
    standalone: false,
})
export class NewPasswordComponent implements OnInit {
    public userActivated = false;
    public tokenExpired = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private toastService: ToastService,
        private userService: UserService,
    ) {}

    ngOnInit(): void {
        this.route.paramMap.subscribe((params: ParamMap) => {
            const token: string | null = params.get('token');
            if (token === undefined || token === null || token.length === 0) {
                this.toastService.error('standard_error', 'public_activation_errortoken');
            } else {
                this.userService.sendNewPassword(token).subscribe({
                    next: () => {
                        this.userActivated = true;
                        this.toastService.success('standard_success', 'public_newpassword_passwordsent');
                    },
                    error: (err) => {
                        if (err.error.message !== undefined) {
                            switch (err.error.message) {
                                case 'Password reset code expired':
                                    this.tokenExpired = true;
                                    break;
                                default:
                                    console.error(err);
                                    this.toastService.toast(StdToasts.STANDARD_ERROR);
                            }
                        } else {
                            this.toastService.error('standard_error', 'public_activation_errortoken');
                        }
                    },
                });
            }
        });
    }

    public goToLogin(): void {
        void this.router.navigate(['login']);
    }

    public goToRequest(): void {
        void this.router.navigate(['lost-password']);
    }
}
